export default `
mutation CreateAffiliate($input: CreateAffiliateInput!) {
  createAffiliate(input: $input) {
    ok
    affiliate {
        id
    }
    error
  }
}
`;
